import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from "@emotion/react";
import { Colors } from "@zapier/design-system";
const styles = css `
  background: none !important;
  border: none;
  color: ${Colors.blueJeans};
  cursor: pointer;
  padding: 0 !important;
  text-decoration: underline;
`;
export const ButtonLink = ({ children, onClick }) => (_jsx("button", { css: styles, onClick: onClick, children: children }));

// @zapier/upsells@8.0.1 (466b4077f)
